"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeMeterDataForEmailDispatch = exports.someRegisterHasPlausibilityError = exports.saveAndForward = exports.registerHasPlausibilityError = exports.prepareMeterReadingData = exports.prepareEnergyTypeForDisplay = exports.pickRegisterFromDeviceByRegisterNumber = exports.isMeterLocked = exports.getObisLabel = exports.getMeterDataForEmailDispatch = exports.formatObis = exports.checkMeterLockedByImplausibleReadingResult = exports.buildMeterDataForEmailDispatch = exports.buildButtonControl = exports.allRegistersHasPlausibilityReason = exports.allMetersLockedByImplausibleReadingResults = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _meterReadingDateInputHelper = require("../../Core/MeterReadDateInput/meterReadingDateInputHelper");
var _meterReadingApi = require("../../../../api/meterReadingApi");
var _mainConfig = _interopRequireDefault(require("../../../../../mainConfig"));
var pickRegisterFromDeviceByRegisterNumber = exports.pickRegisterFromDeviceByRegisterNumber = function pickRegisterFromDeviceByRegisterNumber(registerNumber, registers) {
  return registers.find(function (register) {
    return register.registerNumber === registerNumber;
  }) || {};
};
var prepareMeterReadingData = exports.prepareMeterReadingData = function prepareMeterReadingData(values) {
  var _values$readingDate;
  var meterReadingData = {
    serialNumber: values.serialNumber,
    readingDate: (0, _meterReadingDateInputHelper.returnDateAsArray)((_values$readingDate = values.readingDate) === null || _values$readingDate === void 0 ? void 0 : _values$readingDate.text),
    registers: []
  };
  values.registers.forEach(function (register) {
    if (register.readingNoteNumber) {
      meterReadingData.registers.push({
        registerNumber: register.registerNumber,
        readingResult: parseFloat(register.readingResult.replace(/\./g, '').replace(/,/g, '.')),
        readingNoteNumber: register.readingNoteNumber
      });
    } else {
      meterReadingData.registers.push({
        registerNumber: register.registerNumber,
        readingResult: parseFloat(register.readingResult.replace(/\./g, '').replace(/,/g, '.'))
      });
    }
  });
  return meterReadingData;
};
var buildMeterDataForEmailDispatch = exports.buildMeterDataForEmailDispatch = function buildMeterDataForEmailDispatch(values) {
  var meterDataForEmailDispatch = {
    serialNumber: values.serialNumber,
    registerNumbers: []
  };
  values.registers.forEach(function (register) {
    meterDataForEmailDispatch.registerNumbers.push(register.registerNumber);
  });
  return meterDataForEmailDispatch;
};
var storeMeterDataForEmailDispatch = exports.storeMeterDataForEmailDispatch = function storeMeterDataForEmailDispatch(savedReadingResult) {
  var newResultList = {
    serialNumber: savedReadingResult.serialNumber,
    registerNumbers: savedReadingResult.registerNumbers
  };
  var existingEmailObjectJsonString = window.sessionStorage.getItem('emailObject');
  var emailObject;
  if (existingEmailObjectJsonString) {
    emailObject = JSON.parse(existingEmailObjectJsonString);
    emailObject.resultList.push(newResultList);
  } else {
    emailObject = {
      email: '',
      resultList: [newResultList]
    };
  }
  window.sessionStorage.setItem('emailObject', JSON.stringify(emailObject));
};
var saveAndForward = exports.saveAndForward = function saveAndForward(values, formikHelpers, pagination, currentPageId, lastMeter, setCurrentStep, nextStep) {
  var setSubmitting = formikHelpers.setSubmitting,
    resetForm = formikHelpers.resetForm,
    setFieldValue = formikHelpers.setFieldValue;
  var currentApi = _mainConfig.default.AEM_CONFIG.isA11yModeEnabled ? _meterReadingApi.saveMeterReadingDataOnlyValidate : _meterReadingApi.saveMeterReadingData;
  currentApi(prepareMeterReadingData(values)).then(function () {
    storeMeterDataForEmailDispatch(buildMeterDataForEmailDispatch(values));
    if (lastMeter) {
      setCurrentStep(nextStep);
    } else {
      pagination(currentPageId + 1);
    }
    resetForm();
    setSubmitting(false);
  }).catch(function (error) {
    var tempValues = (0, _toConsumableArray2.default)(values.registers);
    var errors = error.response.data.errors;
    errors.forEach(function (errorItem) {
      if (!(errorItem.code === 'global.validation.missingValue')) {
        var _errorItem$args, _errorItem$args2;
        var fieldValue = ((_errorItem$args = errorItem.args) === null || _errorItem$args === void 0 ? void 0 : _errorItem$args.field) ? (_errorItem$args2 = errorItem.args) === null || _errorItem$args2 === void 0 ? void 0 : _errorItem$args2.field : '';
        var index = parseInt(fieldValue.substring(fieldValue.indexOf('[') + 1, fieldValue.indexOf(']')), 10);
        if (index >= 0) {
          var _errorItem$args3;
          tempValues[index].possibleReadingNotes = (_errorItem$args3 = errorItem.args) === null || _errorItem$args3 === void 0 ? void 0 : _errorItem$args3.readingNotes;
          tempValues[index].errorCode = errorItem.code;
        }
      }
    });
    setFieldValue('registers', tempValues, false);
    setSubmitting(false);
  });
};
var allRegistersHasPlausibilityReason = exports.allRegistersHasPlausibilityReason = function allRegistersHasPlausibilityReason(formikProps) {
  var hasReason = true;
  formikProps.values.registers.forEach(function (register) {
    if (register.possibleReadingNotes && register.possibleReadingNotes.length > 1) {
      if (!register.readingNoteNumber) {
        hasReason = false;
      }
    }
  });
  return hasReason;
};
var registerHasPlausibilityError = exports.registerHasPlausibilityError = function registerHasPlausibilityError(register) {
  var _register$possibleRea;
  var hasApiErrors = false;
  if ((_register$possibleRea = register.possibleReadingNotes) === null || _register$possibleRea === void 0 ? void 0 : _register$possibleRea.length) {
    hasApiErrors = true;
  }
  return hasApiErrors;
};
var someRegisterHasPlausibilityError = exports.someRegisterHasPlausibilityError = function someRegisterHasPlausibilityError(registers) {
  return !!registers.find(function (x) {
    var _x$possibleReadingNot;
    return (_x$possibleReadingNot = x.possibleReadingNotes) === null || _x$possibleReadingNot === void 0 ? void 0 : _x$possibleReadingNot.length;
  });
};
var buildButtonControl = exports.buildButtonControl = function buildButtonControl(continueButtonText, submitButtonText, saveAndContinueButtonText, isLastMeter, isMeterLocked) {
  if (isMeterLocked) {
    return continueButtonText;
  }
  if (isLastMeter) {
    return submitButtonText;
  }
  return saveAndContinueButtonText;
};
var getMeterDataForEmailDispatch = exports.getMeterDataForEmailDispatch = function getMeterDataForEmailDispatch() {
  var emailObjectJsonString = window.sessionStorage.getItem('emailObject');
  if (emailObjectJsonString) {
    return JSON.parse(emailObjectJsonString);
  }
  return {
    email: '',
    resultList: []
  };
};
var prepareEnergyTypeForDisplay = exports.prepareEnergyTypeForDisplay = function prepareEnergyTypeForDisplay(device) {
  var energyTypeKey = device.division;
  var energyTypeValue;
  var energyTypeClass;
  var iconType;
  switch (energyTypeKey) {
    case 'GAS':
      energyTypeValue = 'Gas';
      energyTypeClass = 'ano-meter-informationbox__value__energy-type__gas';
      iconType = 'icon_gas_36x36';
      break;
    case 'POWER':
      energyTypeValue = 'Strom';
      energyTypeClass = 'ano-meter-informationbox__value__energy-type__power';
      iconType = 'icon_strom_36x36';
      break;
    default:
      energyTypeValue = 'Nicht angegeben';
      energyTypeClass = 'ano-meter-informationbox__value__energy-type__gas';
      iconType = 'icon_gas_36x36';
      break;
  }
  return {
    energyTypeValue: energyTypeValue,
    energyTypeClass: energyTypeClass,
    iconType: iconType
  };
};
var getObisLabel = exports.getObisLabel = function getObisLabel(identifier, props) {
  switch (identifier) {
    case 'LABEL_CONSUMER':
      return props.registerLabel;
    case 'LABEL_FEEDIN':
      return props.registerLabelFeedIn;
    case 'LABEL_UNDEFINED':
      return props.registerLabelUndefined;
    default:
      return props.registerLabelUndefined;
  }
};
var formatObis = exports.formatObis = function formatObis(obis) {
  return obis ? obis.split(':')[1] : '';
};
var checkMeterLockedByImplausibleReadingResult = exports.checkMeterLockedByImplausibleReadingResult = function checkMeterLockedByImplausibleReadingResult(device) {
  if (!device.lockReasons) {
    return false;
  }
  return device.lockReasons.filter(function (val) {
    return val === 'LOCKED_BY_IMPLAUSIBLE_LAST_READING_RESULT';
  }).length > 0;
};
var isMeterLocked = exports.isMeterLocked = function isMeterLocked(device) {
  return device.lockReasonWithHighestPriority !== null || checkMeterLockedByImplausibleReadingResult(device);
};
var allMetersLockedByImplausibleReadingResults = exports.allMetersLockedByImplausibleReadingResults = function allMetersLockedByImplausibleReadingResults(devices) {
  if (!devices) {
    return true;
  }
  var deviceCount = devices.length;
  var deviceCountWithImplausibleReadingResult = devices.filter(function (meter) {
    return checkMeterLockedByImplausibleReadingResult(meter);
  }).length;
  return deviceCount === deviceCountWithImplausibleReadingResult;
};